.itemStatic {
  display: flex;
  position: relative;
  flex: 0 0 auto;
  border: 0.0625rem solid var(--neutral-200);
  border-bottom-width: 0.1875rem;
  border-radius: 1.25rem;
  background: var(--neutral);
  box-shadow: 0.1875rem 0.3125rem 2rem -1.5rem rgba(0, 0, 0, 0.33);
  margin: 0 0.625rem 0 0;

  .user {
    z-index: 50;
    position: absolute;
    top: -1rem;
    left: -1rem;
    width: 3.125rem;
    height: 3.125rem;
    border: 0.375rem solid var(--neutral);
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0.25rem 0.25rem 1.25rem -0.375rem rgba(0, 0, 0, 0.25);
  }

  .media {
    display: flex;
    position: relative;
    flex: 0 0 auto;
    max-width: 6rem;
    height: 6rem;
    margin: 0 -0.75rem 0 0;
    padding: 0.75rem;
    border-radius: 1.125rem;
    overflow: hidden;
    background: var(--neutral);

    .mediaImage {
      border-radius: 0.625rem;
      background-color: var(--neutral);
      object-fit: contain;
    }
  }

  .details {
    width: 100%;
    min-width: 0;
  }

  .link {
    display: block;
    opacity: 0.65;
    margin: 0.875rem 0.875rem 0.25rem;
    overflow: hidden;
    font-size: 0.75rem;
    text-align: left;
    text-overflow: ellipsis;
    text-transform: uppercase;
    letter-spacing: 0.035rem;
    white-space: nowrap;
  }

  .name {
    display: block;
    width: 100%;
    max-width: 100%;
    margin: -0.125rem 0.375rem -0.125rem 0.5rem;
    padding: 0.125rem 1.25rem 0.125rem 0.375rem;
    overflow: hidden;
    font-size: 1.125rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .price {
    margin: 0.3125rem 0.875rem 0.875rem;
    column-gap: 0.375rem;

    .priceText {
      font-size: 1.125rem;
      background: linear-gradient(85.25deg, #8fe792 -49.1%, #56a1a7 131.88%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
